import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App.jsx";
import "./styles.css";
import "./styles/theme-dark.css";

// Apply saved theme (light default; "dark" = night-mode) before first paint.
try {
  if (localStorage.getItem("tpm26-theme") === "dark") {
    document.documentElement.setAttribute("data-theme", "dark");
  }
} catch (_) {}

ReactDOM.createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);
